import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";

@injectable()
export class UpdateCacheFromSingleInternalChatUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(internalChat: InternalChatEntity): void {
        return this._repository.updateCacheFromSingleInternalChat(internalChat);
    }
}
